// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"334cb502","378":"71592e55","389":"fd8f91e1","431":"3500fb07","703":"d9dd2dfd"}[chunkId] + ".chunk.css";
};